module.exports = __webpack_public_path__ + "img/link.ad8ca0d2.svg";